import React, { FC } from 'react';
import { Icon } from '../../../components/Icon/Icon';
import { LogoIconKit } from '../../../components/Icon/Icons/LogoIconKit';

export const ProjectLogo: FC = () => {
  return <Icon Component={LogoIconKit} />;
};
